import * as SIGNIFICANT_OTHER from '../../SIGNIFICANT_OTHER';
export var showLogic = SIGNIFICANT_OTHER.logic.show.makeShowSignificantOtherLogic();
